/**
 * Sanitize HTML by removing dangerous tags and event handlers.
 * Used for rendering SBA section content and Q&A answers.
 */
/**
 * ``linkBase`` (e.g. ``https://www.fda.gov``): HTML scraped from another site
 * keeps that site's root-relative links (``/media/123/download``), which would
 * otherwise resolve against our own domain ("No route matched"). They are
 * rewritten onto ``linkBase`` and, like every absolute link, open in a new tab.
 * In-page ``#`` anchors (footnote back-links) are left alone.
 */
export function sanitizeHtml(html: string, linkBase?: string): string {
  if (!html) return '';
  const temp = document.createElement('div');
  temp.innerHTML = html;
  const dangerousTags = temp.querySelectorAll('script, style, iframe, object, embed, link, meta, base');
  dangerousTags.forEach(el => el.remove());
  const allElements = temp.querySelectorAll('*');
  allElements.forEach(el => {
    const attrs = Array.from(el.attributes);
    attrs.forEach(attr => {
      const name = attr.name.toLowerCase();
      if (name.startsWith('on') ||
          (name === 'href' && attr.value.toLowerCase().startsWith('javascript:')) ||
          (name === 'src' && attr.value.toLowerCase().startsWith('javascript:'))) {
        el.removeAttribute(attr.name);
      }
    });
  });
  if (linkBase) {
    temp.querySelectorAll('a[href]').forEach(a => {
      const href = a.getAttribute('href') || '';
      if (href.startsWith('/') && !href.startsWith('//')) a.setAttribute('href', linkBase + href);
      if (/^https?:\/\//i.test(a.getAttribute('href') || '')) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }
  return temp.innerHTML;
}
